// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3JfmV","head":"Table_head__3tsbF","col":"Table_col__3lcoq"};